import {
    FiBarChart2 as DashboardIcon, FiLogOut as LogoutIcon,
    FiSettings as SettingsIcon, FiShoppingBag as SubscriptionsIcon,
    FiTag as LoansIcon, FiTrendingUp as TransactionsIcon
} from "react-icons/fi";
import { HiOutlineMenuAlt4 as MenuIcon } from "react-icons/hi";
import { useIsFetching } from 'react-query';
import { useRouteMatch } from "react-router-dom";
import { useAuth } from "../contexts/Auth.context";
import { useScreenSize } from "../lib/useMedia";
import BrandLogo from "./BrandLogo";
import Button from "./Button";
import Dropdown from "./Dropdown";
import { SwingIndicator } from "./Spinner";

export default function Header() {
    const { authenticatedUser: user } = useAuth()
    const isFetching = useIsFetching()
    const breakPoint = useScreenSize()
    const disable = useRouteMatch({ path: ['/signup', '/login', "/"], exact: true, strict: true })
    const isAuthenticated = user && user.email

    if (disable) return null

    return (
        <header
            style={{ zIndex: 100 }}
            className={`h-16 flex items-center px-4 sm:px-6 relative justify-between border-b
                ${isAuthenticated ? "bg-indigo-600 shadow-md border-indigo-200" : "bg-white border-gray-300 shadow"}
            `}
        >
            <BrandLogo light={isAuthenticated} />
            {
                isAuthenticated ?
                    <AuthenticatedHeader breakPoint={breakPoint} user={user} /> :
                    <DefaultHeader breakPoint={breakPoint} />
            }
            {
                isFetching ? <SwingIndicator /> : null
            }
        </header>
    )
}

function AuthenticatedHeader({ breakPoint, user }) {
    const { logout } = useAuth()
    const isLargeScreen = breakPoint === "lg"

    const menuListAll = [
        { label: "Dashboard", link: "dashboard", icon: <DashboardIcon /> },
        { label: "Transactions", link: "transactions", icon: <TransactionsIcon /> },
        { label: "Subscriptions", link: "subscriptions", icon: <SubscriptionsIcon /> },
        { label: "My Loans", icon: <LoansIcon />, link: "loans" },
        { label: "Settings", link: "profile", icon: <SettingsIcon />, borderTop: true },
    ]

    const menuList = [{ label: "Sign out", icon: <LogoutIcon />, callback: () => logout() }]

    const emailDisplay = <div className="px-4 py-3">
        <p className="text-sm leading-5">Signed in as</p>
        <p className="text-sm font-medium leading-5 text-gray-900 truncate">{user.email}</p>
    </div>

    return (
        <div className="ml-auto h-full flex items-center space-x-4 sm:space-x-6">
            {
                //on large screens the sidebar is already showing, so only show the second menu... otherwise show both
                // menuList={isLargeScreen ? menuList2 : [...menuList, ...menuList2]}
            }
            <Dropdown header={emailDisplay} menuList={isLargeScreen ? menuList : [...menuListAll, ...menuList]}>
                <div className="p-2 cursor-pointer">
                    <MenuIcon className="text-white h-7 w-7" />
                </div>
            </Dropdown>
        </div>
    )
}

function DefaultHeader({ breakPoint }) {
    const links = [
        { label: "Sign in", link: "/login", borderTop: true, skip: true },
        { label: "Sign up for free", link: "/signup", skip: true }
    ]

    if (breakPoint === "xs") return (
        <div className="ml-auto">
            <Dropdown menuList={links} width="w-44">
                <MenuIcon className="text-indigo-600 h-7 w-7 cursor-pointer" />
            </Dropdown>
        </div>
    )

    return (
        <div className="ml-auto flex items-center space-x-2">
            <Button variant="outline" border="border-gray-300" goto="/login">Sign in</Button>
            <Button goto="/signup">Sign up for free</Button>
        </div>
    )
}

